import React from 'react'
import { MenuItem, Typography } from '@material-ui/core'
import { SelectFormsy } from '@fuse'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

export default (props) => {
  const {
    label,
    name,
    value,
    formFields,
    setFormFields,
    propOfCountryCode,
    propOfRegionType,
    propOfCountryId,
    showPassportCode,
  } = props
  const { formatMessage } = useIntl()
  const countryList = useSelector(({ countries }) => countries.countryList)

  return (
    <SelectFormsy
      className="w-full"
      name={name}
      label={formatMessage({ id: label })}
      value={value}
      variant="standard"
    >
      {countryList.length
        ? countryList.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => {
                  setFormFields({
                    ...formFields,
                    [propOfCountryCode]: item.code.toLowerCase(),
                    [propOfRegionType]: item.regionType,
                    [propOfCountryId]: item.id,
                    passportCountryCode: item.id,
                  })
                }}
              >
                <Typography>
                  {item.name} {showPassportCode && `(${item.code})`}
                </Typography>
              </MenuItem>
            )
          })
        : null}
    </SelectFormsy>
  )
}
